import { type ProductDto2 } from '@Shared/api/full';

export const PriceCell = ({ product }: { product: ProductDto2 | null | undefined }) =>
    new Intl.NumberFormat('ru-RU', { style: 'currency', currency: product?.currency?.shortCode }).format(
        Number(product?.price),
    );
